// FFXIV 天气系统常量配置
export const WEATHER_CONFIG = {
    // 艾欧泽亚时间与现实时间比例 (1 ET = 175 秒现实时间)
    EORZEAN_TIME_RATIO: 175,

    // 天气周期持续时间 (8 ET小时 = 1400现实秒)
    WEATHER_CYCLE_DURATION: 8 * 175 * 1000, // 毫秒

    // 天气图标映射
    WEATHER_ICONS: {
        "阴云": { id: 60203, url: "http://huiji-public.huijistatic.com/ff14/uploads/3/33/060203.png" },
        "碧空": { id: 60201, url: "http://huiji-public.huijistatic.com/ff14/uploads/f/f6/060201.png" },
        "晴朗": { id: 60202, url: "http://huiji-public.huijistatic.com/ff14/uploads/d/de/060202.png" },
        "薄雾": { id: 60204, url: "http://huiji-public.huijistatic.com/ff14/uploads/6/63/060204.png" },
        "小雨": { id: 60207, url: "http://huiji-public.huijistatic.com/ff14/uploads/9/9a/060207.png" },
        "微风": { id: 60205, url: "http://huiji-public.huijistatic.com/ff14/uploads/6/6c/060205.png" },
        "暴雨": { id: 60208, url: "http://huiji-public.huijistatic.com/ff14/uploads/9/96/060208.png" },
        "强风": { id: 60206, url: "http://huiji-public.huijistatic.com/ff14/uploads/1/19/060206.png" },
        "打雷": { id: 60209, url: "http://huiji-public.huijistatic.com/ff14/uploads/d/d5/060209.png" },
        "雷雨": { id: 60210, url: "http://huiji-public.huijistatic.com/ff14/uploads/d/db/060210.png" },
        "扬沙": { id: 60211, url: "http://huiji-public.huijistatic.com/ff14/uploads/3/32/060211.png" },
        "热浪": { id: 60214, url: "http://huiji-public.huijistatic.com/ff14/uploads/6/6c/060214.png" },
        "暴雪": { id: 60216, url: "http://huiji-public.huijistatic.com/ff14/uploads/9/9a/060216.png" },
        "小雪": { id: 60215, url: "http://huiji-public.huijistatic.com/ff14/uploads/6/6e/060215.png" },
        "妖雾": { id: 60218, url: "http://huiji-public.huijistatic.com/ff14/uploads/2/21/060218.png" },
        "灵电": { id: 60220, url: "http://huiji-public.huijistatic.com/ff14/uploads/2/23/060220.png" },
        "灵风": { id: 60219, url: "http://huiji-public.huijistatic.com/ff14/uploads/1/19/060219.png" },
        "月尘": { id: 60222, url: "http://huiji-public.huijistatic.com/ff14/uploads/8/89/060222.png" },
        "磁暴": { id: 60223, url: "http://huiji-public.huijistatic.com/ff14/uploads/c/ca/060223.png" }
    },

    // 地区天气概率配置
    WEATHER_RATES: {
        "利姆萨·罗敏萨上层甲板": ["阴云", 20, "碧空", 50, "晴朗", 80, "薄雾", 90, "小雨"],
        "利姆萨·罗敏萨下层甲板": ["阴云", 20, "碧空", 50, "晴朗", 80, "薄雾", 90, "小雨"],
        "乌尔达哈现世回廊": ["碧空", 40, "晴朗", 60, "阴云", 85, "薄雾", 95, "小雨"],
        "乌尔达哈来生回廊": ["碧空", 40, "晴朗", 60, "阴云", 85, "薄雾", 95, "小雨"],
        "格里达尼亚新街": ["小雨", 5, "小雨", 20, "薄雾", 30, "阴云", 40, "晴朗", 55, "碧空", 85, "晴朗"],
        "格里达尼亚旧街": ["小雨", 5, "小雨", 20, "薄雾", 30, "阴云", 40, "晴朗", 55, "碧空", 85, "晴朗"],
        "中拉诺西亚": ["阴云", 20, "碧空", 50, "晴朗", 70, "微风", 80, "薄雾", 90, "小雨"],
        "拉诺西亚低地": ["阴云", 20, "碧空", 50, "晴朗", 70, "微风", 80, "薄雾", 90, "小雨"],
        "海雾村": ["阴云", 20, "碧空", 50, "晴朗", 70, "晴朗", 80, "薄雾", 90, "小雨"],
        "东拉诺西亚": ["薄雾", 5, "碧空", 50, "晴朗", 80, "阴云", 90, "小雨", 95, "暴雨"],
        "西拉诺西亚": ["薄雾", 10, "碧空", 40, "晴朗", 60, "阴云", 80, "微风", 90, "强风"],
        "拉诺西亚高地": ["碧空", 30, "晴朗", 50, "阴云", 70, "薄雾", 80, "打雷", 90, "雷雨"],
        "西萨纳兰": ["碧空", 40, "晴朗", 60, "阴云", 85, "薄雾", 95, "小雨"],
        "中萨纳兰": ["扬沙", 15, "碧空", 55, "晴朗", 75, "阴云", 85, "薄雾", 95, "小雨"],
        "东萨纳兰": ["碧空", 40, "晴朗", 60, "阴云", 70, "薄雾", 80, "小雨", 85, "暴雨"],
        "南萨纳兰": ["热浪", 20, "碧空", 60, "晴朗", 80, "阴云", 90, "薄雾"],
        "北萨纳兰": ["碧空", 5, "晴朗", 20, "阴云", 50, "薄雾"],
        "黑衣森林中央林区": ["打雷", 5, "小雨", 20, "薄雾", 30, "阴云", 40, "晴朗", 55, "碧空", 85, "晴朗"],
        "黑衣森林东部林区": ["打雷", 5, "小雨", 20, "薄雾", 30, "阴云", 40, "晴朗", 55, "碧空", 85, "晴朗"],
        "黑衣森林南部林区": ["薄雾", 5, "雷雨", 10, "打雷", 25, "薄雾", 30, "阴云", 40, "晴朗", 70, "碧空"],
        "黑衣森林北部林区": ["薄雾", 5, "暴雨", 10, "小雨", 25, "薄雾", 30, "阴云", 40, "晴朗", 70, "碧空"],
        "库尔札斯中央高地": ["暴雪", 20, "小雪", 60, "晴朗", 70, "碧空", 75, "阴云", 90, "薄雾"],
        "摩杜纳": ["阴云", 15, "薄雾", 30, "妖雾", 60, "碧空", 75, "晴朗"],
        "拉诺西亚外地": ["碧空", 30, "晴朗", 50, "阴云", 70, "薄雾", 85, "小雨"],
        "狼狱停船场": ["阴云", 20, "碧空", 50, "晴朗", 80, "薄雾", 90, "雷雨"],
        "薰衣草苗圃": ["阴云", 5, "小雨", 20, "薄雾", 30, "阴云", 40, "晴朗", 55, "碧空", 85, "晴朗"],
        "高脚孤丘": ["碧空", 40, "晴朗", 60, "阴云", 85, "薄雾", 95, "小雨"],
        "库尔札斯西部高地": ["暴雪", 20, "小雪", 60, "晴朗", 70, "碧空", 75, "阴云", 90, "薄雾"],
        "龙堡参天高地": ["阴云", 10, "薄雾", 20, "打雷", 30, "扬沙", 40, "碧空", 70, "晴朗"],
        "龙堡内陆低地": ["阴云", 10, "薄雾", 20, "小雨", 30, "暴雨", 40, "碧空", 70, "晴朗"],
        "翻云雾海": ["阴云", 10, "强风", 20, "灵电", 40, "碧空", 70, "晴朗"],
        "阿巴拉提亚云海": ["碧空", 30, "晴朗", 60, "阴云", 70, "薄雾", 80, "微风", 90, "灵风"],
        "魔大陆阿济兹拉": ["晴朗", 35, "阴云", 70, "打雷"],
        "伊修加德基础层": ["小雪", 60, "晴朗", 70, "碧空", 75, "阴云", 90, "薄雾"],
        "伊修加德砥柱层": ["小雪", 60, "晴朗", 70, "碧空", 75, "阴云", 90, "薄雾"],
        "田园郡": ["阴云", 10, "薄雾", 20, "小雨", 30, "暴雨", 40, "碧空", 70, "晴朗"],
        "基拉巴尼亚边区": ["碧空", 15, "晴朗", 60, "阴云", 80, "薄雾", 90, "打雷"],
        "红玉海": ["打雷", 10, "微风", 20, "阴云", 35, "晴朗", 75, "碧空"],
        "延夏": ["暴雨", 5, "小雨", 15, "薄雾", 25, "阴云", 40, "晴朗", 80, "碧空"],
        "基拉巴尼亚山区": ["碧空", 10, "晴朗", 60, "阴云", 75, "薄雾", 85, "微风", 95, "扬沙"],
        "基拉巴尼亚湖区": ["碧空", 20, "晴朗", 60, "阴云", 80, "薄雾", 90, "雷雨"],
        "太阳神草原": ["强风", 5, "微风", 10, "小雨", 17, "薄雾", 25, "阴云", 35, "晴朗", 75, "碧空"],
        "黄金港": ["小雨", 10, "薄雾", 20, "阴云", 40, "晴朗", 80, "碧空"],
        "神拳痕": ["碧空", 15, "晴朗", 60, "阴云", 80, "薄雾", 90, "打雷"],
        "白银乡": ["小雨", 10, "薄雾", 20, "阴云", 40, "晴朗", 80, "碧空"],
        "优雷卡常风之地": ["晴朗", 30, "强风", 60, "暴雨", 90, "小雪"],
        "优雷卡恒冰之地": ["晴朗", 10, "薄雾", 28, "热浪", 46, "小雪", 64, "打雷", 82, "暴雪"],
        "优雷卡涌火之地": ["晴朗", 10, "热浪", 28, "打雷", 46, "暴雪", 64, "灵风", 82, "小雪"],
        "雷克兰德": ["碧空", 20, "晴朗", 60, "阴云", 75, "薄雾", 85, "小雨", 95, "雷雨"],
        "珂露西亚岛": ["强风", 10, "小雨", 20, "薄雾", 30, "阴云", 45, "晴朗", 85, "碧空"],
        "安穆·艾兰": ["晴朗", 45, "阴云", 60, "扬沙", 70, "热浪", 80, "碧空"],
        "伊尔美格": ["小雨", 10, "薄雾", 20, "阴云", 35, "雷雨", 45, "碧空", 60, "晴朗"],
        "拉凯提卡大森林": ["薄雾", 10, "小雨", 20, "灵风", 30, "碧空", 45, "晴朗", 85, "阴云"],
        "黑风海": ["阴云", 20, "晴朗", 80, "碧空"],
        "水晶都": ["碧空", 20, "晴朗", 60, "阴云", 75, "薄雾", 85, "小雨", 95, "雷雨"],
        "游末邦": ["强风", 10, "小雨", 20, "薄雾", 30, "阴云", 45, "晴朗", 85, "碧空"],
        "优雷卡丰水之地": ["晴朗", 12, "暴雨", 34, "妖雾", 56, "雷雨", 78, "小雪"],
        "南方博兹雅战线": ["晴朗", 52, "小雨", 64, "微风", 76, "打雷", 88, "扬沙"],
        "迷津": ["碧空", 15, "晴朗", 60, "阴云", 85, "小雨"],
        "萨维奈岛": ["薄雾", 10, "小雨", 20, "暴雨", 25, "碧空", 40, "晴朗", 80, "阴云"],
        "加雷马": ["小雪", 45, "打雷", 50, "小雨", 55, "薄雾", 60, "阴云", 85, "晴朗", 95, "碧空"],
        "叹息海": ["灵风", 15, "月尘", 30, "晴朗"],
        "天外天垓": ["磁暴", 15, "晴朗", 85, "灵风"],
        "厄尔庇斯": ["阴云", 25, "灵风", 40, "晴朗", 85, "碧空"],
        "旧萨雷安": ["碧空", 10, "晴朗", 50, "阴云", 70, "薄雾", 85, "小雪"],
        "拉札罕": ["薄雾", 10, "小雨", 25, "碧空", 40, "晴朗", 80, "阴云"],
        "扎杜诺尔高原": ["晴朗", 60, "小雨", 70, "微风", 80, "打雷", 90, "小雪"]
    },

    // 地区分组
    REGIONS: [
        {
            name: "拉诺西亚",
            locations: [
                "利姆萨·罗敏萨上层甲板",
                "中拉诺西亚",
                "拉诺西亚低地",
                "东拉诺西亚",
                "西拉诺西亚",
                "拉诺西亚高地",
                "拉诺西亚外地",
                "狼狱停船场",
                "海雾村"
            ]
        },
        {
            name: "黑衣森林",
            locations: [
                "格里达尼亚新街",
                "黑衣森林中央林区",
                "黑衣森林东部林区",
                "黑衣森林南部林区",
                "黑衣森林北部林区",
                "薰衣草苗圃"
            ]
        },
        {
            name: "萨纳兰",
            locations: [
                "乌尔达哈现世回廊",
                "西萨纳兰",
                "中萨纳兰",
                "东萨纳兰",
                "南萨纳兰",
                "北萨纳兰",
                "高脚孤丘"
            ]
        },
        {
            name: "库尔札斯",
            locations: [
                "伊修加德基础层",
                "库尔札斯中央高地",
                "库尔札斯西部高地"
            ]
        },
        {
            name: "阿巴拉提亚",
            locations: [
                "阿巴拉提亚云海",
                "魔大陆阿济兹拉"
            ]
        },
        {
            name: "龙堡",
            locations: [
                "田园郡",
                "龙堡参天高地",
                "龙堡内陆低地",
                "翻云雾海"
            ]
        },
        {
            name: "基拉巴尼亚",
            locations: [
                "神拳痕",
                "基拉巴尼亚边区",
                "基拉巴尼亚山区",
                "基拉巴尼亚湖区"
            ]
        },
        {
            name: "远东之国",
            locations: [
                "黄金港",
                "白银乡"
            ]
        },
        {
            name: "奥萨德",
            locations: [
                "红玉海",
                "延夏",
                "太阳神草原"
            ]
        },
        {
            name: "诺弗兰特",
            locations: [
                "水晶都",
                "游末邦",
                "雷克兰德",
                "珂露西亚岛",
                "安穆·艾兰",
                "伊尔美格",
                "拉凯提卡大森林",
                "黑风海"
            ]
        },
        {
            name: "摩杜纳",
            locations: ["摩杜纳"]
        },
        {
            name: "伊尔萨巴德",
            locations: [
                "拉札罕",
                "萨维奈岛",
                "加雷马"
            ]
        },
        {
            name: "北洋地域",
            locations: [
                "旧萨雷安",
                "迷津"
            ]
        },
        {
            name: "星外天域",
            locations: [
                "叹息海",
                "天外天垓"
            ]
        },
        {
            name: "古代世界",
            locations: ["厄尔庇斯"]
        },
        {
            name: "优雷卡",
            locations: [
                "优雷卡常风之地",
                "优雷卡恒冰之地",
                "优雷卡涌火之地",
                "优雷卡丰水之地"
            ]
        },
        {
            name: "博兹雅",
            locations: [
                "南方博兹雅战线",
                "扎杜诺尔高原"
            ]
        }
    ],

    // 地区名称映射
    LOCATION_MAPPING: {
        "利姆萨·罗敏萨上层甲板": "利姆萨·罗敏萨",
        "格里达尼亚新街": "格里达尼亚",
        "乌尔达哈现世回廊": "乌尔达哈",
        "伊修加德基础层": "伊修加德"
    }
}

// 时间格式化选项
export const TIME_FORMATS = {
    eorzean: {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    },
    local: {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    },
    server: {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'UTC'
    }
}